import { Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { DataRow } from '../../../MACRA_1/components/Table/ITable';
import Table from '../../../MACRA_1/components/Table/Table';
import * as BeMaccaferriStoreHelper from '../../../api/store/BeMaccaferriStoreHelper';
import { endpointMacra2 } from '../../pages';
import { useCallback, useEffect, useState } from 'react';
import { useAppDispatch } from '../../../../reduxService/hooks';
import { EProjectType } from '../../../enum/project';

interface IPanelTemplateMacra2Props {}

const PanelTemplateMacra2 = (props: IPanelTemplateMacra2Props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [templates, setTemplates] = useState<DataRow[]>([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);

    const setTempaleDataRowAsync = useCallback(async (page?: number, newPerPage?: number, name?: string) => {
        let templateResponse = await BeMaccaferriStoreHelper.getGCSPreviewTemplatesAsync(page, newPerPage, name);
        let templateDataRow: DataRow[] = templateResponse.data.data.map(temp => ({ id: temp.id, name: temp.name, creationDate: temp.creationDate, isTemplate: true }));
        setTemplates(templateDataRow);
        setTotalRows(templateResponse.data.pagesCount * perPage);
    }, []);

    const fetchTemplates = async (page: number) => {
        setLoading(true);
        setTempaleDataRowAsync(page, perPage);
        setLoading(false);
    };

    const handlePageChange = (page: number) => {
        fetchTemplates(page);
    };

    const handlePerRowsChange = async (newPerPage: number, page: number) => {
        setLoading(true);
        setTempaleDataRowAsync(page, newPerPage);
        setPerPage(newPerPage);
        setLoading(false);
    };

    useEffect(() => {
        fetchTemplates(1);
    }, []);

    const handleSearch = async (e: React.ChangeEvent<HTMLInputElement>) => {
        setTempaleDataRowAsync(1, perPage, e.target.value);
    };

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(e.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleNew = async (type: EProjectType) => {
        navigate(endpointMacra2.macra2BackofficeTemplate + '/type/' + type);
    };

    return (
        <div className='panel-container'>
            <div className='nosubmit d-flex justify-content-between mb-4'>
                <input className='nosubmit' type='search' placeholder='Search...' onChange={handleSearch} />
                <button type='button' onClick={handleClick}>
                    {t('backoffice_newTemplate')}
                </button>
                <Menu
                    id='basic-menu-help'
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}>
                    <MenuItem onClick={() => handleNew(EProjectType.VerticalDrop)}>{t('backoffice_macra2_vertical')}</MenuItem>
                    <MenuItem onClick={() => handleNew(EProjectType.SteppedWeir)}>{t('backoffice_macra2_stepped_weir')}</MenuItem>
                    <MenuItem onClick={() => handleNew(EProjectType.SlopedWeir)}>{t('backoffice_macra2_sloped_weir')}</MenuItem>
                </Menu>
            </div>

            <Table
                isMacra2
                data={templates}
                progressPending={loading}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
            />
        </div>
    );
};

export default PanelTemplateMacra2;
